import { FontWeight } from '../../../enums/fontWeight'
import { Weight } from '../types/weight'

export const weightToValue: Record<Weight, FontWeight> = {
  light: FontWeight.Light,
  regular: FontWeight.Regular,
  medium: FontWeight.Medium,
  semiBold: FontWeight.SemiBold,
  bold: FontWeight.Bold,
  extraBold: FontWeight.ExtraBold,
  black: FontWeight.Black,
}
